
import styled from 'styled-components'

import FONTS from 'constants/fonts'
import MEDIA from 'constants/media'


import { Props } from './types'

export const RadioOptionHiddenInput = styled.input.attrs(() => ({ type: 'radio' }))`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const attrs = styled.label.attrs((props: Props) => ({ className: props.checked ? 'checked' : '' }))

export const RadioOptionLabel = attrs<Props>`
  font-size: ${FONTS.FONTINPUTSMOBILE};
  border: 1px solid #e0d6b6;
  border-radius: 4px;
  display: block;
  padding: 15px;
  margin: 10px 0;
  max-width: 460px;
  text-align: center;
  ${MEDIA.medium`
    font-size: ${FONTS.FONTINPUTS};
  `}
  transition: background-color 100ms linear;
  will-change: background-color, border;
  background-color: #f8f4e5;
  &:hover {
    background-color: #f7eaba;
    border: 1px solid #f3dd93;
  }
  &.checked,
  &:active,
  &:focus {
    background-color: #f3dd93;
  }
  span {
    font-size: 18px;
  }
`
